import { OktaAuthOptions } from "@okta/okta-auth-js";
import { environment } from "src/environments/environment";

export const oktaConfig: OktaAuthOptions = {
    clientId: environment.oktaConfig.clientId,
    issuer: environment.oktaConfig.issuer,
    redirectUri: `${window.location.origin}/callback`,
    scopes: environment.oktaConfig.scopes,
    pkce: true,
    logoutUrl:''
}